import { Header } from '../components/Header';
import { PageIntro } from '../components/PageIntro';
import { ServicesSection } from '../components/ServicesSection';
import { ProcessSection } from '../components/ProcessSection';
import { BriefSection } from '../components/BriefSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
export function ServicesPage() {
  return (
    <>
      <Header />
      <PageIntro
        eyebrow="Услуги"
        title="Точные данные. Обоснованные решения."
        description="Аудит финансовой отчётности, проверка запасов и основных средств, аналитические отчёты для руководства."
      />
      <ServicesSection expanded />
      <ProcessSection />
      <BriefSection />
      <FAQSection />
      <Footer />
    </>
  );
}
